import { ThemeIcon } from '@src/theme/ThemeIcon';
import { SvgArtwork } from '@src/theme/SvgArtwork';
import heart from './assets/heart.svg?raw';
import cup from './assets/cup.svg?raw';
import home from './assets/home.svg?raw';
import edit from './assets/edit.svg?raw';
import gift from './assets/gift.svg?raw';
import './HomeArtwork.css';

const artwork = { heart, cup, home, edit, gift };
export type HomeArtworkName = keyof typeof artwork;

/** Exchange-category icons use the active theme override or the default illustration. */
export function HomeArtwork({ name }: { name: HomeArtworkName }) {
  return (
    <ThemeIcon
      name={name}
      className="home-artwork"
      fallback={<SvgArtwork className="home-artwork" svg={artwork[name]} />}
    />
  );
}
